import { render, staticRenderFns } from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=template&id=f95bd932&"
import script from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierManualPurchasingPriceArtikelFiltersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports